import poSimple from '../../assets/images/backoffice/settings-inventory/po_simple.png';
import poAdvanced from '../../assets/images/backoffice/settings-inventory/po_advanced.png';
import transferSimple from '../../assets/images/backoffice/settings-inventory/transfer_simple.png';
import transferAdvanced from '../../assets/images/backoffice/settings-inventory/transfer_advanced.png';
import adjustmentSimple from '../../assets/images/backoffice/settings-inventory/adjustment_simple.png';
import adjustmentAdvanced from '../../assets/images/backoffice/settings-inventory/adjustment_advanced.png';
import { ConfigSelection } from '../../types/settings/InventorySetting';

export const CONFIG_SELECTIONS: ConfigSelection[] = [
  {
    name: 'purchase_order_config',
    title: 'Purchase Order Configuration',
    titleLabel:
      'Set your business level Inventory process for Purchase Order. This will be applied to All Outlets.',
    testId: 'purchase-order',
    featureFlag: 'advancedInventoryPurchaseOrderUi',
    options: {
      simple: {
        label: 'Simple Purchase Order',
        image: poSimple,
        description:
          'Assigned employees can create Purchase Order. Stock changes will be applied immediately to Inventory.',
        permissions: [],
      },
      advanced: {
        label: 'Advanced Purchase Order',
        image: poAdvanced,
        description:
          'Assigned employees can create Purchase Order requests. Purchase Order must be Approved and Fulfilled before stock changes can be applied to Inventory.',
        permissions: [
          {
            name: 'request_purchase_order',
            label: 'Request PO',
            labelUi: 'PO Requests',
            testId: 'request-purchase-order',
          },
          {
            name: 'approve_purchase_order',
            label: 'Approve PO',
            labelUi: 'PO Approval',
            testId: 'approve-purchase-order',
          },
          {
            name: 'fullfill_purchase_order',
            label: 'Fulfillment PO',
            labelUi: 'PO Fulfillment',
            testId: 'fulfillment-purchase-order',
          },
        ],
      },
    },
  },
  {
    name: 'transfer_config',
    title: 'Transfer Configuration',
    titleLabel:
      'Set your business level Inventory process for Transfer. This will be applied to All Outlets.',
    testId: 'transfer',
    options: {
      simple: {
        label: 'Simple Transfer',
        image: transferSimple,
        description:
          'Assigned employees can request Transfer from other Outlets in Moka. Stock changes will be applied immediately to Inventory.',
        permissions: [],
      },
      advanced: {
        label: 'Advanced Transfer',
        image: transferAdvanced,
        description:
          'Assigned employees can request Transfer from other Outlets in Moka. Transfer requests must go through Approval, Shipment, and Fulfillment processes before stock changes can be applied to Inventory.',
        permissions: [
          {
            name: 'request_transfer_request',
            label: 'Request Transfer',
            labelUi: 'Transfer Requests',
            testId: 'request-transfer',
          },
          {
            name: 'approve_transfer_request',
            label: 'Approve Transfer',
            labelUi: 'Transfer Approval',
            testId: 'approve-transfer',
          },
          {
            name: 'shipment_transfer_request',
            label: 'Transfer Shipment',
            labelUi: 'Transfer Shipment',
            testId: 'transfer-shipment',
          },
          {
            name: 'fullfill_transfer_request',
            label: 'Transfer Fulfillment',
            labelUi: 'Transfer Fulfillment',
            testId: 'transfer-fulfillment',
          },
        ],
      },
    },
  },
  {
    name: 'adjustment_config',
    title: 'Adjustment Configuration',
    titleLabel:
      'Set your business level Inventory process for Adjustment. This will be applied to All Outlets.',
    testId: 'adjustment',
    featureFlag: 'advancedInventoryAdjustmentSettingUi',
    options: {
      simple: {
        label: 'Simple Adjustment',
        image: adjustmentSimple,
        description:
          'Assigned employees can create Adjustment for their outlets. Stock changes will be applied immediately to Inventory.',
        permissions: [],
      },
      advanced: {
        label: 'Advanced Adjustment',
        image: adjustmentAdvanced,
        description:
          'Assigned employees can create Adjustment for their outlets. Adjustment requests must go through the Approval process before stock changes can be applied to Inventory.',
        permissions: [
          {
            name: 'request_adjustment',
            label: 'Request Adjustments',
            labelUi: 'Adjustment Requests',
            testId: 'request-adjustment',
          },
          {
            name: 'approve_adjustment',
            label: 'Approve Adjustments',
            labelUi: 'Adjustment Approval',
            testId: 'approve-adjustment',
          },
        ],
      },
    },
  },
];
